import { gql } from '@apollo/client'

export default gql`
  mutation M($product: ProductInput!) {
    upsertProduct (product: $product) {
      id
    }
  }
`
